var map = {
	"./ar": 742,
	"./ar.js": 742,
	"./de": 743,
	"./de.js": 743,
	"./es": 744,
	"./es.js": 744,
	"./fr": 745,
	"./fr.js": 745,
	"./hi": 746,
	"./hi.js": 746,
	"./it": 747,
	"./it.js": 747,
	"./ja": 748,
	"./ja.js": 748,
	"./ko": 749,
	"./ko.js": 749,
	"./pt": 750,
	"./pt.js": 750,
	"./ru": 751,
	"./ru.js": 751,
	"./zh-cn": 752,
	"./zh-cn.js": 752,
	"./zh-hk": 753,
	"./zh-hk.js": 753,
	"./zh-tw": 754,
	"./zh-tw.js": 754
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1790;


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web-ui@1/node_modules/_@bone_bone-web-ui@1.0.7@@bone/bone-web-ui/lib/_components/@alife/next-moment/lib/locale ^\.\/.*$
// module id = 1790
// module chunks = 2